import $ from "jquery";

const miReviewSlider = () => {
    const init = () => {
        execute()
    }

    const execute = () => {
        const el = {
            main: '.mi-ReviewSlider__track'
        }
        if ($(el.main).length === 0) return

        $(el.main).each(function () {
            // Make slider infinite by duplicating content
            const $slider = $(this);
            if (!$slider.hasClass('mi-ReviewSlider__track--cloned')) {
                $slider.append($slider.html());
                $slider.addClass('mi-ReviewSlider__track--cloned');
            }
        })
    }
    init()
}

try {
    miReviewSlider()
} catch (error) {
    console.error('miReviewSlider', error)
}